export default "__VITE_ASSET__IxSz6l5Z__"